import { render, staticRenderFns } from "./ImageSliderBlock.vue?vue&type=template&id=a8ff54f2"
import script from "./ImageSliderBlock.vue?vue&type=script&lang=js"
export * from "./ImageSliderBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports